// Constants for word candidate generation and filtering
export const MIN_WORD_LENGTH = 3;
export const MAX_WORD_LENGTH = 8;

